import { Injectable } from '@angular/core';
import { APIService } from 'src/app/api';
import { ConfirmRegistration, ConfirmTokenValidity } from 'KiaLearn.Common/angular-common-libraries/projects/web-api-client/src/lib/generated/kia-authentication-api-client';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationAPIService {
  constructor(private apiService: APIService) {
  }

  async checkTokenValidity(email: string, token: string): Promise<boolean> {
    const validityRequest = new ConfirmTokenValidity();
    validityRequest.email = email;
    validityRequest.token = token;
  
    try {
      const isTokenValid = await this.apiService.getKiaAuthenticationApiClient().postCheckTokenValidity(validityRequest);
      return isTokenValid;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  confirmRegistration(confirmedRegistrationModel: ConfirmRegistration) {
    return this.apiService.getKiaAuthenticationApiClient().confirmRegistration(confirmedRegistrationModel);
  }
}
